import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amp'
})
export class AmpPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace('&', 'and');
  }

}
